import { useFirm } from '../queries/use-firm';
import { useFirmContext } from '../providers/FirmProvider';
import { Spinner } from '@cimplico/components';
import ErrorSplashScreen from './ErrorSplashScreen';
import NewPageContainer from '../components/page-container/NewPageContainer';
import FirmOverview from '../features/firm-overview/firm-information/FirmOverview';
import FirmSettings from '../features/firm-overview/firm-settings/FirmSettings';

function FirmSettingsPage(): JSX.Element {
    const { id } = useFirmContext();
    const firmQuery = useFirm(id);

    if (firmQuery.isLoading) {
        return (
            <div className="absolute w-full h-[calc(100vh-56px)]">
                <div className="absolute top-1/3 left-1/2">
                    <Spinner />
                </div>
            </div>
        );
    }

    if (firmQuery.isError || !firmQuery.isSuccess) {
        if (firmQuery.error?.response?.status === 404) {
            return (
                <ErrorSplashScreen
                    errorCode={404}
                    title="Firm not found."
                    redirectTitle="Back to onboarding"
                    redirectUrl="/onboarding"
                    leftArrow={true}
                />
            );
        }
        return (
            <ErrorSplashScreen
                title="An error has occurred."
                redirectTitle="Back to onboarding"
                redirectUrl="/onboarding"
                leftArrow={true}
            />
        );
    }

    const { firm } = firmQuery.data;

    return (
        <NewPageContainer>
            <div className="grid gap-y-4 mx-8 xl:mx-auto max-w-[1240px]">
                <FirmOverview firm={firm} />
                <FirmSettings firm={firm} />
            </div>
        </NewPageContainer>
    );
}
export default FirmSettingsPage;
